import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { ConfigService } from "@Common/config";
import { CommonUrlService } from "@Common/util/common-url.service";

@Component({
standalone: false,
  selector: 'fx-ssh-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css']
})
export class FooterComponent implements OnInit {

  constructor(private url: CommonUrlService, private cs: ConfigService, private cdr: ChangeDetectorRef) { }
  build;
  advanced;
  advancedDisabled;
  config$;
  ngOnInit() {
    this.config$ = this.cs.subscribe (d => {
      this.build = d.build;
      this.advanced = d.advanced;
      this.advancedDisabled = d["advanced-disabled"];
      this.cdr.detectChanges();
    });
  }
  ngOnDestroy () {
    this.config$.unsubscribe ();
  }
  poweredBy () {
    return this.url.poweredBy ();
  }
  release () {
    return this.url.release ();
  }
  

}
